import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Table, Image, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { AddLabel } from './forms/AddLabel'
import { EditLabel } from './forms/EditLabel'
import { getLabels } from '../../api/fetch'
import { labelFetch } from '../../api/fetch'
import { AlertModal } from './forms/commons/AlertModal'

import './labels.css'


export const Labels = (props) => {

    const [labels, setLabels] = useState([])
    const [loading, setLoading] = useState(false)
    const [showAddForm, setShowAddForm] = useState(false)
    const [showEditForm, setShowEditForm] = useState(false)
    const [labelSelected, setLabelSelected] = useState({})
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [labelToDelete, setLabelToDelete] = useState({})

    useEffect(() => {
        if (props.parent.id && !loading) {
            fetchLabels(props.parent.id.split('-')[1])
        }
    }, [props.parent])

    const scrollToForm = () => {
        window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
    }
    const handleAddLabel = () => {
        setShowEditForm(false)
        setShowAddForm(true)

        setTimeout(function () {
            scrollToForm()
        }, 200);
    }

    const handleDestroyForms = () => {
        setShowAddForm(false)
        setShowEditForm(false)
        if (!loading) fetchLabels(props.parent.id.split('-')[1])
    }

    const fetchLabels = (async (id) => {
        setLoading(true)
        setLabels([])
        const method = 'GET'
        const result = await getLabels({ method, id });
        if (result) setLabels(result)
        setLoading(false)
    })
    const deleteLabel = (async () => {
        setLoading(true)
        const method = "DELETE"
        const body = JSON.stringify(labelToDelete)
        const headers = {
            'Content-Type': 'application/json',
        }
        await labelFetch({ method, body, headers });
        fetchLabels(props.parent.id.split('-')[1])
    })
    const editLabel = (label) => {
        setShowAddForm(false)
        setLabelSelected(label)
        setShowEditForm(true)

        setTimeout(function () {
            scrollToForm()
        }, 200);
    }

    const handleDelete = (label) => {
        setLabelToDelete(label)
        setShowDeleteModal(true)
    }

    return (
        <Container>
            {showDeleteModal ?
                <Row>
                    <Col>
                        <AlertModal message="Are you sure you want to delete?" primaryAction={deleteLabel} show={showDeleteModal} setShow={setShowDeleteModal} element={labelToDelete} />
                    </Col>
                </Row>
                : <div />
            }
            <Row className="title">
                <Col>
                    <h2>{props.parent.name + " > Labels"}</h2>
                </Col>
            </Row>
            {loading ? <div>Loading...</div> :
                <div id="labels-table" className="scrollable">
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Picture</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <>
                                {labels.map(label => (
                                    <tr key={label.id}>
                                        <td>{label.name}</td>
                                        <td><Image src={label.image} thumbnail width="70" height="80"></Image></td>
                                        <td><FontAwesomeIcon className="c-black me-2 button" icon={faEdit} onClick={() => editLabel(label)} /></td>
                                        <td><FontAwesomeIcon className="c-black me-2 button" icon={faTrash} onClick={() => handleDelete(label)} /></td>
                                    </tr>
                                ))}
                            </>
                        </tbody>
                    </Table>
                </div>
            }
            {labels.length === 0 ? <Row className="no-label-text"><Col className="text-center font-size-20">No labels</Col></Row> : <div />}
            <Button className="bg-dark-blue mt-2" variant="primary" type="button" onClick={() => handleAddLabel()}>
                Add Label
            </Button>
            {showAddForm ? <AddLabel parent={props.parent} destroyForm={handleDestroyForms} /> : <div />}
            {showEditForm ? <EditLabel parent={props.parent} elementSelected={labelSelected} destroyForm={handleDestroyForms} /> : <div />}
        </Container>
    )
}